import { useEffect, useRef } from 'react'
import { useMutation } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'

import { authApi } from '@/api/auth'
import { Alert, AuthLayout } from '@/components/ui'
import { useApiError } from '@/features/auth/useApiError'
import { useAuthStore } from '@/stores/authStore'

/** Προορισμός του συνδέσμου που στέλνεται με email: /auth/magic?token=… */
export default function MagicVerifyPage() {
  const { t } = useTranslation()
  const [params] = useSearchParams()
  const navigate = useNavigate()
  const setSession = useAuthStore((s) => s.setSession)
  const translateError = useApiError()
  const attempted = useRef(false)

  const mutation = useMutation({
    mutationFn: authApi.verifyMagicLink,
    onSuccess: (session) => {
      setSession(session)
      navigate('/', { replace: true })
    },
  })

  const token = params.get('token')

  useEffect(() => {
    // Το token είναι μονοχρηστικό, οπότε η επαλήθευση δεν επαναλαμβάνεται
    // ούτε στο διπλό mount του React StrictMode.
    if (!token || attempted.current) return
    attempted.current = true
    mutation.mutate(token)
  }, [token, mutation])

  return (
    <AuthLayout
      title={t('auth.magicVerify.title')}
      footer={
        <Link to="/magic-link" className="font-semibold text-brand-700 underline">
          {t('auth.magicVerify.requestNew')}
        </Link>
      }
    >
      {!token && <Alert>{t('auth.magicVerify.missingToken')}</Alert>}
      {token && mutation.isPending && <p className="text-gray-500">{t('common.loading')}</p>}
      {mutation.isError && <Alert>{translateError(mutation.error)}</Alert>}
    </AuthLayout>
  )
}
